<div class="modal-header">
  <h5 class="modal-title">Attention! Impossible de faire cette action puisque que le questionnaire a déjà été
    soumis.</h5>
</div>
<div class="modal-body">
  <p>Il impossible d'effectuer cette action puisque que le questionnaire a déjà été soumis.</p>
</div>
<div class="modal-footer">
  <button (click)="activeModal.close(false)" class="btn btn-primary" data-bs-dismiss="modal" type="button">Ok</button>
</div>
